<template>
  <el-dialog
    title="机构员工"
    :visible.sync="visible"
    width="640px"
    append-to-body=""
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.staffName"
        placeholder="请输入姓名"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      max-height="600"
      border
      :data="list">
      <el-table-column
        label="姓名"
        prop="staffName">
      </el-table-column>
      <el-table-column
        label="手机号"
        width="120"
        prop="mobile">
      </el-table-column>
      <el-table-column
        label="邮箱"
        width="160"
        prop="email">
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="90">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="updateitem(row)">编辑</el-button>
          <el-button
            type="text"
            @click="deleteitem(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button
        type="primary"
        @click="additem">新 增</el-button>
      <el-button @click="visible = false">关 闭</el-button>
    </div>
    <edit-org-user-modal
      ref="user"
      @fetch="fetchList" />
  </el-dialog>
</template>
<script>
import EditOrgUserModal from './edit-org-user-modal.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'OrgStaffModal',
  components: { EditOrgUserModal },
  data() {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, staffName: '', orgId: null },
      list: [],
      total: 0
    }
  },
  methods: {
    additem() {
      this.$refs.user.update({ orgId: this.config.orgId })
    },
    updateitem(row) {
      const { account, email, mobile, orgId, staffId, staffName, userType } = row
      this.$refs.user.update({ account, email, mobile, orgId, staffId, staffName, userType })
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm(`您确定删除该机构员工?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          OrgService.deletestaff({ staffId: row.staffId, orgId: row.orgId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleClosed() {
      this.list = []
      this.total = 0
      this.config = { ...this.config, ...this.$options.data().config }
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      OrgService.getstaffs({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options) {
      this.config.orgId = options.orgId
      this.fetchList()
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
